module.exports = __webpack_public_path__ + "static/img/5.126f2ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx/5.png
// module id = AJ+J
// module chunks = 1